// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__CwnVs","media":"styles_media__rixdE","content":"styles_content__AQ_3k","title":"styles_title__vJGZk","info":"styles_info__8g0_s","date":"styles_date__lWVHS"};
module.exports.__checksum = "e60f2182dbb7"